import { useContext, useEffect, useState } from 'react';
import { SystemContext } from '../System';
import { Permission } from '@journeyapps-platform/types-cardinal';

export function usePermissions() {
  const system = useContext(SystemContext);
  const [permissions, setPermissions] = useState<null | undefined | Permission[]>(null);

  useEffect(() => {
    (async () => {
      setPermissions(await system.loadUserPermissions());
    })();
  }, []);

  return permissions;
}
